import { render, staticRenderFns } from "./Toplist.vue?vue&type=template&id=1f9ba948&scoped=true"
import script from "./Toplist.vue?vue&type=script&lang=js"
export * from "./Toplist.vue?vue&type=script&lang=js"
import style0 from "./Toplist.vue?vue&type=style&index=0&id=1f9ba948&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9ba948",
  null
  
)

export default component.exports